import columnConfig from "../../components/IncomingOrders/helpers/columnConfig";
import ColumnType from "../../components/IncomingOrders/helpers/ColumnType";

export const ROOT_GROUP_ID = "__root__";
export const DEFAULT_SORT_FIELD = columnConfig[ColumnType.SUPPLIER_ORDER_NO].sortField;

export const createInitialQueryParams = () => ({
  offset: 0,
  pageSize: 10,
  sortField: DEFAULT_SORT_FIELD,
  sortDesc: true,
  searchTerm: "",
  supplierOrderStatusId: null,
  supplierOrderStatusIds: [],
});

export const TABLE_HEADERS = [
  ColumnType.ORDER_TYPE,
  ColumnType.SUPPLIER_ORDER_NO,
  ColumnType.SUPPLIER_ORDER_REFERENCE,
  ColumnType.ORDER_REFERENCE,
  ColumnType.RECEIVER,
  ColumnType.ORDER_DATE,
  ColumnType.SUMMARY,
  ColumnType.DELIVERY_ADDRESS_2,
  ColumnType.DELIVERY_DATE,
  ColumnType.ORDER_STATUS,
  ColumnType.SOURCE,
  ColumnType.ROW_COUNT,
];

export const EMPTY_FILTERS = {
  supplierOrderStatusIds: [],
  productTypes: [],
  dateFrom: null,
  dateTo: null,
  deliveryDateFrom: null,
  deliveryDateTo: null,
  orderingCompanyIds: [],
};

export const chipStyles = {
  type: { bg: "#FEF3C7", color: "#92400E" },
  status: { bg: "#FCE7F3", color: "#9D174D" },
  neutral: { bg: "rgba(0,0,0,0.05)", color: "text.secondary" },
};